import { RefObject, useState } from 'react';

import { useIntersectionCallbacks } from '@/hooks/useIntersectionCallbacks';

export type UseVimeoViewportPlaybackOptions = Pick<
	IntersectionObserverInit,
	'root' | 'threshold'
> & {
	scrollMargin?: string;
};

export const useVimeoViewportPlayback = (
	rootRef: RefObject<Element | null>,
	options?: UseVimeoViewportPlaybackOptions
): boolean => {
	const [playing, setPlaying] = useState(false);
	const { root, threshold = 0, scrollMargin } = options ?? {};

	useIntersectionCallbacks([rootRef], {
		onEntry: () => setPlaying(true),
		onLeave: () => setPlaying(false),
		root,
		scrollMargin,
		threshold
	});

	return playing;
};
